import { render, staticRenderFns } from "./previewBooking_component.vue?vue&type=template&id=1ac361a0&scoped=true&"
import script from "../../assets/customer/js/previewBooking.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/previewBooking.js?vue&type=script&lang=js&"
import style0 from "./previewBooking_component.vue?vue&type=style&index=0&id=1ac361a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac361a0",
  null
  
)

export default component.exports